import React from "react";

const DesarrolloWeb = () => {
  return (
    <>
      <div className="info">
        <p>
          {" "}
          Tenemos las habilidades y el talento para el desarrollo de diseño web,
          desarrollo de software, apli-caciones, animación, video, piezas
          gráﬁcas, consultoría y marketing, para comunicar la causa de nuestros
          clientes. Los años de experiencia, combinados con la habilidad y
          dedicación, porque nos gusta lo que hacemos, hacen que los
          profesionales seamos lo que somos hoy, una empresa líder en soluciones
          digitales para todo tipo de organizaciones, empresas y
          personas.Nuestras herramientas y soluciones son los vehículos para
          entregar el mensaje de nuestros clientes. Tenemos la experiencia
          necesaria para garantizar su satisfacción y éxito.
          <br />
          Creamos, diseñamos y desarrollamos sitios y proyectos web a medida
          según las necesidades del cliente, para que tengan una presencia
          notoria y de alta calidad en Internet. Le damos a nuestros clientes un
          producto práctico, eﬁciente y atractivo, para que el proyecto genere
          en la web una marcada diferencia.
        </p>
        <h4>Desarrollamos</h4>
        <ul>
          <li>Sitios web</li>
          <li>Email Marketing</li>
          <li>Newsletter</li>
          <li>Banners</li>
          <li>Redes Sociales (community management)</li>
          <li>E-commerce</li>
          <li>Blogs</li>
        </ul>
      </div>
    </>
  );
};

export default DesarrolloWeb;
